import React from 'react';
import './modal-close-button.scss';
import { CloseOutlinedIcon } from 'components/icons/close-outlined';
import { ModalCloseButtonProps } from './modal-close-button-props';

/**
 * A simple button to close an open modal.
 *
 * Place this either in or alongside the `DialogTitle`.
 * @param props
 */
export const ModalCloseButton: React.FC<ModalCloseButtonProps> = (props) => {
  const {
    fullScreen,
    onClose,
  } = props;

  return (
    <div className={`sg-modal-close-button ${fullScreen ? 'sg-modal-close-button--fullscreen' : ''}`}>
      <CloseOutlinedIcon
        fontSize="inherit"
        onClick={onClose}
      />
    </div>
  );
};
